import { SALES_PAYMENT_CREATE_RESET, SALES_PAYMENT_LIST_REQUEST, SALES_PAYMENT_LIST_SUCCESS, SALES_PAYMENT_LIST_FAIL, SALES_PAYMENT_CREATE_REQUEST, SALES_PAYMENT_CREATE_SUCCESS, SALES_PAYMENT_CREATE_FAIL } from '../constants/salesPaymentConstants';

export const salesPaymentListReducer = (state = { salesPayments: [] }, action) => {
  switch (action.type) {
    case SALES_PAYMENT_LIST_REQUEST:
      return { ...state, loading: true }; // Preserve existing sales payments while loading
    case SALES_PAYMENT_LIST_SUCCESS:
      return { loading: false, salesPayments: action.payload };
    case SALES_PAYMENT_LIST_FAIL:
      return { loading: false, error: action.payload, salesPayments: state.salesPayments };
    default:
      return state;
  }
};

export const salesPaymentCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case SALES_PAYMENT_CREATE_REQUEST:
      return { loading: true };
    case SALES_PAYMENT_CREATE_SUCCESS:
      return { loading: false, success: true, salesPayment: action.payload };
    case SALES_PAYMENT_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case SALES_PAYMENT_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

